<template>
	<button 
		class="btn"
		:class="btnNextEstagio.class"
		v-if="available"
		@click="nextEstagio()">
		<i class="fas mr-2" :class="btnNextEstagio.icone"></i>
		{{ btnNextEstagio.nome }}
	</button>
</template>

<script>
	export default {
		props: ['dados'],
		data(){
			return {
				btnNextEstagio: [],
				pedido: this.dados.pedido,
				available: true
			}
		},
		created(){
			this.setAvailable();
			this.setBtn();
		},
		methods: {
			setAvailable(){
				if(
					(this.dados.estagio_id < 3) 
					&& (this.pedido.estagio_id == 2)
					&& (
						(this.dados.quantidade == 1) 
						|| (this.dados.estagio_id == 1) 
						|| (this.dados.quantidade_finalizada == this.dados.quantidade)
					)
				){
					this.available = true;
				} else {
					this.available = false;
				}
			},
			setBtn(){
				if(this.dados.estagio_id == 1){
					this.btnNextEstagio = {
						class: 'btn-primary',
						nome: 'Iniciar Produção',
						icone: 'fa-wrench'
					}
				}
				if(this.dados.estagio_id == 2){
					this.btnNextEstagio = {
						class: 'btn-success',
						nome: 'Finalizar',
						icone: 'fa-check'
					}
				}
			},
			nextEstagio(){
				var config = {
					position: 'bottom-right',
				};
				axios.put(this.$url+'/api/adm/itens/next-estagio/'+this.$route.params.id)
	            .then(response => {
	            	this.$bshMessage.show(response.data.message, response.data.type, config)
	            	this.$emit('reload');
	            })
	            .catch(error => {
	            	this.$bshMessage.show(error.response.data.message, 'error')
	            });
			},
		}
	}
</script>